import React from 'react';
import './Details.css';
// Import SVG images
import easyIcon from '../../assets/easy-icon.svg';
import customizableIcon from '../../assets/customizable-icon.svg';
import privateIcon from '../../assets/private-icon.svg';

function Details() {
  // Renamed array from testimonials to infoCards
  const infoCards = [
    {
      id: 0,
      image: easyIcon,
      mainText: "\"Having access to instant, compassionate support anytime has completely transformed how I handle stress. The gentle reminders from my AI therapist help me stay grounded and kind to myself throughout the day.\"",
      secondaryText: "User on developing daily emotional resilience",
      color: '#f6efe7'
    },
    {
      id: 1,
      image: customizableIcon,
      mainText: "\"This AI therapist guided me through some really difficult emotions with patience and understanding. It felt like talking to someone who genuinely cared—it's reshaped my thinking in ways I didn't expect.\"",
      secondaryText: "User on overcoming negative thought patterns",
      color: '#f6efe7'
    },
    {
      id: 2,
      image: privateIcon,
      mainText: "\"Being able to talk openly without judgment, any time of day, changed everything for me. This AI therapist helped me reconnect with myself and taught me how to handle my anxiety better than ever before.\"",
      secondaryText: "User on building a healthier relationship with themselves",
      color: '#f6efe7'
    }
  ];

  return (
    <section className="details-section">
      <div className="container">
        <h2 className="section-title">Instant access to ai therapy</h2>
        <p className="section-description">
          Meet the AI therapist built to support you—anytime, anywhere,<br />
          with care that grows smarter every day.
        </p>

        <div className="stats-container">
          <div className="rating-block">
            <div className="stars">
              <span className="star">⭐</span>
              <span className="star">⭐</span>
              <span className="star">⭐</span>
              <span className="star">⭐</span>
            </div>
            <span className="rating-text">Users rating</span>
          </div>

          <div className="stat-item">
            <h3>100M +</h3>
            <p>Tokens used</p>
          </div>

          <div className="stat-item">
            <h3>8,000 +</h3>
            <p>Minutes in therapy</p>
          </div>
        </div>

        <div className="info-cards-container">
          <div className="info-cards-grid">
            {infoCards.map((card) => (
              <div
                key={card.id}
                className="info-card"
                style={{ backgroundColor: card.color }}
              >
                <div className="card-content">
                  <p className="card-main-text">{card.mainText}</p>
                  <p className="card-secondary-text">{card.secondaryText}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Details; 